import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
export default {
  name: "CircuitRoutingRender",
  components: {
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      boardSize: 440,
      boardPadding: 48,
      cellSize: 68,
      options: ["true", "false"],
      optionLabels: ["可以连通", "无法连通"]
    };
  },
  computed: {
    components() {
      return Array.isArray(this.data?.components) ? this.data.components : [];
    },
    gridSize() {
      return Number(this.data?.gridSize || 5);
    },
    gridPixels() {
      return this.gridSize * this.cellSize;
    },
    gridLines() {
      return Array.from({
        length: this.gridSize + 1
      }, (_, index) => index);
    },
    pairs() {
      const found = {};
      this.components.forEach(component => {
        if (!found[component.pairId]) {
          found[component.pairId] = {
            pairId: component.pairId,
            symbol: component.symbol
          };
        }
      });
      const visualPairs = [{
        leftSymbol: "switch",
        rightSymbol: "resistor"
      }, {
        leftSymbol: "capacitor",
        rightSymbol: "battery"
      }, {
        leftSymbol: "wave",
        rightSymbol: "ground"
      }];
      return Object.values(found).map((pair, index) => ({
        ...pair,
        ...visualPairs[index % visualPairs.length]
      }));
    },
    displayComponents() {
      const occurrence = {};
      return this.components.map(component => {
        const pairIndex = this.pairs.findIndex(pair => pair.pairId === component.pairId);
        const pair = this.pairs[pairIndex] || {
          leftSymbol: "switch",
          rightSymbol: "resistor"
        };
        const count = occurrence[component.pairId] || 0;
        occurrence[component.pairId] = count + 1;
        return {
          ...component,
          displaySymbol: count % 2 === 0 ? pair.leftSymbol : pair.rightSymbol
        };
      });
    },
    solutionPaths() {
      return this.reviewMode && Array.isArray(this.data?.solutionPaths) ? this.data.solutionPaths : [];
    }
  },
  methods: {
    gridCoordinate(index) {
      return this.boardPadding + index * this.cellSize;
    },
    cellCenter(index) {
      return this.boardPadding + index * this.cellSize + this.cellSize / 2;
    },
    pathPoints(path) {
      const cells = Array.isArray(path?.cells) ? path.cells : [];
      return cells.map(cell => `${this.cellCenter(cell.col)},${this.cellCenter(cell.row)}`).join(" ");
    },
    onChoose(values) {
      this.$emit("answer", values && values.length ? values[0] : null);
    },
    answerLabel(value) {
      return String(value) === "true" ? "可以连通" : "无法连通";
    },
    symbolName(symbol) {
      return {
        antenna: "天线",
        capacitor: "电容",
        relay: "继电器"
      }[symbol] || "元件";
    },
    glyphMarkup(symbol) {
      const glyphs = {
        switch: '<path d="M-14-13V13M-8-13V13M-18-6H-4M-18 5H-4M-14-4L-3-14M-8 5L3-6" /><circle cx="-14" cy="-6" r="2" />',
        resistor: '<path d="M-20 0h7l4-7 5 14 5-14 5 14 5-7h9" />',
        capacitor: '<circle r="14" /><path d="M-19 0h9M10 0h10M-10-5H10M-10 0H10M-10 5H10M-5-12v24M5-12v24" />',
        battery: '<path d="M-20 0h8M-8-12v24M1-8v16M7 0h13M-13-7v14" />',
        wave: '<circle r="14" /><path d="M-20 0h6M-10 0c3-9 7-9 10 0s7 9 10 0M14 0h10" />',
        ground: '<path d="M0-20v23M-10 3H10M-7 8H7M-4 13H4" />'
      };
      return glyphs[symbol] || glyphs.switch;
    }
  }
};